/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuperSearchResponse } from '../models/SuperSearchResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SuperSearchService {
  /**
   * @param q
   * @param limit
   * @param includeDocuments
   * @param includeSavedDestinations
   * @param contextFirmId
   * @param contextCompanyId
   * @param contextMeasurementDate
   * @returns SuperSearchResponse
   * @throws ApiError
   */
  public static apiSuperSearchList(
    q?: string,
    limit: number = 100,
    includeDocuments: boolean = false,
    includeSavedDestinations: boolean = false,
    contextFirmId?: number,
    contextCompanyId?: number,
    contextMeasurementDate?: string,
  ): CancelablePromise<SuperSearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/super-search',
      query: {
        'q': q,
        'limit': limit,
        'include_documents': includeDocuments,
        'include_saved_destinations': includeSavedDestinations,
        'context_firm_id': contextFirmId,
        'context_company_id': contextCompanyId,
        'context_measurement_date': contextMeasurementDate,
      },
    });
  }
}
